import { Download } from 'lucide-react';
import Button from './Button';

const ExportButton = ({ onClick, loading = false, disabled = false, title }) => (
  <Button variant="outline-primary" size="sm" onClick={onClick} loading={loading} disabled={disabled} title={title}>
    {!loading && <Download className="w-4 h-4" aria-hidden="true" />}
    {loading ? 'Exporting…' : 'Export'}
  </Button>
);

export default ExportButton;
